function shouldBeConverted(value: unknown): boolean {
  if (value instanceof Date) {
    return false;
  }

  if (typeof value !== 'string') {
    return false;
  }

  const isoDateRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?Z?$/;

  return isoDateRegex.test(value);
}

export function convertDates<T>(data: T): T {
  if (data instanceof File || data instanceof Blob) {
    return data;
  }

  if (Array.isArray(data)) {
    return data.map(item => convertDates(item)) as T;
  }

  if (data !== null && typeof data === 'object') {
    return Object.fromEntries(
      Object.entries(data as Record<string, unknown>).map(([key, value]) => [
        key,
        convertDates(value),
      ]),
    ) as T;
  }

  if (shouldBeConverted(data)) {
    return new Date(data as string) as T;
  }

  return data;
}
